import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=941c0938&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"
import style0 from "./BaseLoader.vue?vue&type=style&index=0&id=941c0938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941c0938",
  null
  
)

export default component.exports